/** @jsxRuntime classic */
/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { Colors, Typography } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import { COLOR_KEYS, MEDIA_MIN_WIDTH } from '../../../constants';
import { TweetProps } from '../../ScrollingTweets/Tweet';
import { ScrollingTweets } from '../../ScrollingTweets/ScrollingTweets';

export interface ScrollingTweetsSectionProps {
  backgroundColor:
    | typeof COLOR_KEYS.blue10
    | typeof COLOR_KEYS.bolt
    | typeof COLOR_KEYS.neutral100
    | typeof COLOR_KEYS.peach;
  heading: string;
  tweets: Omit<TweetProps, 'ariaHidden'>[];
}

const Styles = labelStyles('ScrollingTweetsSection', {
  root: (backgroundColor: ScrollingTweetsSectionProps['backgroundColor']) =>
    css({
      backgroundColor: Colors[backgroundColor],
      padding: '64px 0 56px',

      [MEDIA_MIN_WIDTH.small]: {
        padding: '80px 0 72px',
      },

      [MEDIA_MIN_WIDTH.large]: {
        padding: '96px 0 88px',
      },
    }),

  heading: css({
    ...Typography.pageHeader7,
    color: Colors.earth,
    textAlign: 'center',
    maxWidth: '320px',
    margin: '0 auto 48px',

    [MEDIA_MIN_WIDTH.small]: {
      maxWidth: '640px',
      marginBottom: '64px',
    },

    [MEDIA_MIN_WIDTH.large]: {
      ...Typography.pageHeader5,
      maxWidth: '768px',
      marginBottom: '80px',
    },
  }),
});

export function ScrollingTweetsSection(props: ScrollingTweetsSectionProps) {
  return (
    <div css={Styles.root(props.backgroundColor)}>
      {props.heading && <h2 css={Styles.heading}>{props.heading}</h2>}
      <ScrollingTweets tweets={props.tweets} />
    </div>
  );
}
